export const appConfig = {
  brandName: 'Art-Taste',
  city: 'Gurugram, Haryana',
  collectionName: process.env.REACT_APP_FIRESTORE_ORDERS_COLLECTION || 'orders',
  maxFileSizeBytes: 100 * 1024 * 1024,
  maxCopies: 500,
  maxPages: 2000,
  storeLaunchDate:
    process.env.REACT_APP_STORE_LAUNCH_DATE || '2026-05-01T00:00:00+05:30',
};

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
};

export const hasFirebaseConfig = Object.values(firebaseConfig).every(Boolean);
export const apiBaseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
export const hasApiConfig = Boolean(apiBaseUrl);

export const cashfreeConfig = {
  mode: process.env.REACT_APP_CASHFREE_MODE || 'sandbox',
  appId: process.env.REACT_APP_CASHFREE_APP_ID || '',
  sessionUrl: process.env.REACT_APP_CASHFREE_SESSION_URL || '',
  enabled: (process.env.REACT_APP_CASHFREE_ENABLED || 'true').toLowerCase() !== 'false',
};

export const isCashfreeLive = Boolean(hasApiConfig && cashfreeConfig.enabled);
